<template>
    <div>
      <v-card
        color="grey lighten-4"
        flat
        tile
      >
      <v-toolbar color="red" dark dense flat>
        <v-btn
               @click="emitChanges"
               icon
        >
          <v-icon>$vuetify.icons.values.mdiMenu</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <router-link to="/">
        <v-btn color="black lighten-5"> <v-icon class="pr-1">$vuetify.icons.values.mdiLogoutVariant</v-icon>{{$t('msg.logout')}}</v-btn>
        </router-link>
      </v-toolbar>
      </v-card>
    </div>
</template>

<script>
import { EventBus } from '../main'
export default {
  name: 'Header',
  methods: {
    handleLogout: function () {
      window.location.href =  'appLogout'
    },
    emitChanges: function () {
      EventBus.$emit('Clicked')
    }
  }
}
</script>
